import data from '../components/region-bounding-boxes.json';

export const ROUTE_ZINDEX = 10;
export const BEACON_ZINDEX = 20;
export const USER_ZINDEX = 30;
export const POPUP_ZINDEX = 40;
export const CONTROL_ZINDEX = 50;

export interface Location {
    lat: number;
    lng: number;
}

export interface BoundingBox {
    minX: number;
    maxX: number;
    minY: number;
    maxY: number;
}

export interface RegionBoundingBoxMap {
    [isoAlpha2: string]: RegionBoundingBox;
}

export interface RegionBoundingBox {
    sw: {
        lat: number;
        lon: number;
    };
    ne: {
        lat: number;
        lon: number;
    };
}

export function getLocaleRegionBoundingBox(
    region: 'eu' | 'us'
): RegionBoundingBox {
    return regionBoundingBoxes[region === 'us' ? 'US' : 'GB'];
}

export function locationsToBounds(
    locations: { lat: number; lng: number }[]
): RegionBoundingBox {
    const boundingBox = getBoundingBox(locations);
    return {
        ne: {
            lat: boundingBox.maxX,
            lon: boundingBox.maxY
        },
        sw: {
            lat: boundingBox.minX,
            lon: boundingBox.minY
        }
    };
}

export function getBoundingBox(points: Location[]): BoundingBox {
    let minX = 0,
        maxX = 0,
        minY = 0,
        maxY = 0;

    // init first point
    if (points.length > 0) {
        ((point) => {
            minX = point.lat;
            maxX = point.lat;
            minY = point.lng;
            maxY = point.lng;
        })(points[0]);
    }

    // calculate rect
    points.forEach((point) => {
        minX = Math.min(minX, point.lat);
        maxX = Math.max(maxX, point.lat);
        minY = Math.min(minY, point.lng);
        maxY = Math.max(maxY, point.lng);
    });

    return { minX, maxX, minY, maxY };
}

export function increaseBoundsBy(
    bounds: RegionBoundingBox,
    percent: number
): RegionBoundingBox {
    const latDiff = (bounds.ne.lat - bounds.sw.lat) * (percent / 100);
    const lngDiff = (bounds.ne.lon - bounds.sw.lon) * (percent / 100);

    return {
        ne: {
            lat: bounds.ne.lat + latDiff,
            lon: bounds.ne.lon + lngDiff
        },
        sw: {
            lat: bounds.sw.lat - latDiff,
            lon: bounds.sw.lon - lngDiff
        }
    };
}

const regionBoundingBoxes: RegionBoundingBoxMap = data;
